import Router from 'routes';
import ThemeProvider from './theme';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeLocalization from 'components/ThemeLocalization';
import 'shepherd.js/dist/css/shepherd.css';
import { QueryClient, QueryClientProvider } from 'react-query';

import { ConnectedAppsProvider } from 'contexts/ConnectedAppsContext';
import { useEffect } from 'react';

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vbg2wvs0to");
    `;
    document.head.appendChild(script);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <ConnectedAppsProvider>
        <ThemeProvider>
          <ThemeColorPresets>
            <ThemeLocalization>
              <Router />
            </ThemeLocalization>
          </ThemeColorPresets>
        </ThemeProvider>
      </ConnectedAppsProvider>
    </QueryClientProvider>
  );
}

export default App;
